import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import Stat from './Stat';
import useDeviationStats from './useDeviationStats';
const CommentStat = (_param)=>{
    var { deviation, onlyNumbers, withUserList = true, className } = _param, baseProps = _object_without_properties(_param, [
        "deviation",
        "onlyNumbers",
        "withUserList",
        "className"
    ]);
    const { comments, isCommentable } = useDeviationStats(deviation);
    return !isCommentable ? null : /*#__PURE__*/ React.createElement(Stat, _object_spread({
        className: className,
        deviation: deviation,
        statCount: comments,
        icon: CommentIcon,
        onlyNumbers: onlyNumbers,
        userListType: withUserList ? 'comment' : undefined,
        statNameLocaleKey: "deviation.stats.comments",
        biData: BiData({
            evid: 2,
            click_info: 'comments',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }, baseProps));
};
CommentStat.displayName = 'CommentStat';
export default CommentStat;

//# sourceMappingURL=CommentStat.js.map